<template>
  <div>
    <v-row>
      <v-col>
        <v-tabs
          v-model="activeTab"
          show-arrows
          grow
          class="user-tabs"
        >
          <v-tab
            v-for="tab in tabs"
            :key="tab.icon"
            @click="getTipoSolicitacao"
          >
            <v-icon
              size="20"
              class="me-3"
            >
              {{ tab.icon }}
            </v-icon>
            <span>{{ tab.title }}</span>
          </v-tab>

          <v-tab
            :to="{ name: 'tipos-solicitacoes' }"
          >
            <v-icon
              color="error"
            >
              {{ icons.mdiCloseCircleOutline }}
            </v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items
          v-model="activeTab"
          class="mt-5"
        >
          <div style="min-height: 4px">
            <v-progress-linear
              v-if="loading"
              indeterminate
            ></v-progress-linear>
          </div>

          <v-tab-item>
            <tipo-solicitacao-tab
              :tipo-solicitacao-data="tipoSolicitacaoData"
              :acesso-put="acessoPut"
              @update:active-tab="tab => activeTab = tab"
            />
          </v-tab-item>

          <v-tab-item>
            <tipo-solicitacao-filas-tab />
          </v-tab-item>

          <v-tab-item>
            <tipo-solicitacao-formulario-tab />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import { mapState } from 'pinia'
import { mdiBookmarkOutline, mdiCloseCircleOutline, mdiShape, mdiPlusBoxMultiple } from '@mdi/js'
import router from '@/router'
import TipoSolicitacaoTab from '@/views/tipo-solicitacao/tipo-solicitacao-tab/TipoSolicitacaoTab.vue'
import TipoSolicitacaoFilasTab from '@/views/tipo-solicitacao/filas-tab/TipoSolicitacaoFilasTab.vue'
import TipoSolicitacaoFormularioTab from '@/views/tipo-solicitacao/formularios-tab/TipoSolicitacaoTabFormularios.vue'
import useAuthStore from '@/store/auth'
import TipoSolicitacaoService from '@/services/modules/TipoSolicitacaoService'

export default {
  components: {
    TipoSolicitacaoTab,
    TipoSolicitacaoFilasTab,
    TipoSolicitacaoFormularioTab,
  },

  data() {
    return {
      idPut: 1052,
      acessoPut: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  mounted() {
    // this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPut)) {
        this.acessoPut = false
      }
    },
  },

  setup() {
    const activeTab = ref(0)
    const tipoSolicitacaoData = ref({})
    const loading = ref(false)

    const tabs = [
      {
        icon: mdiBookmarkOutline,
        title: 'Tipo de solicitação',
      },
      {
        icon: mdiPlusBoxMultiple,
        title: 'Filas',
      },
      {
        icon: mdiShape,
        title: 'Formulários',
      },
    ]

    async function getTipoSolicitacao() {
      loading.value = true

      TipoSolicitacaoService
        .getById(router.currentRoute.params.id)
        .then(response => {
          tipoSolicitacaoData.value = response.data.data
          setTimeout(() => {
            loading.value = false
          }, 1000)
        })
        .catch(() => {
          loading.value = false
        })
    }

    onMounted(async () => { await getTipoSolicitacao() })

    return {
      activeTab,
      tipoSolicitacaoData,
      loading,
      tabs,
      getTipoSolicitacao,
      icons: {
        mdiCloseCircleOutline,
        mdiShape,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';

.v-slide-group__content{
  display: flex;
  flex: 1 0 auto;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  justify-content: space-between;
}
</style>
